import React, { useState } from 'react';
import { db } from '../../firebase/firebase-config';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { User, Phone, Calendar, Clock, Save, FileText } from 'lucide-react';
import './AddAppointmentView.css';

const AddAppointmentView = ({ onComplete }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    date: '',
    time: '',
    notes: '',
    status: 'Onaylandı' // Doktor girdiği için direkt onaylı başlıyor
  });

  // AddAppointmentView.jsx içindeki handleSubmit fonksiyonun şu şekilde olsun:
const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await addDoc(collection(db, "appointments"), {
      fullName: formData.fullName,
      phone: formData.phone,
      date: formData.date,
      time: formData.time,
      notes: formData.notes || "", // Panelde fazladan not alanı var
      status: "Onaylandı", // Doktor girdiği için direkt onaylı
      createdAt: serverTimestamp(),
      source: "Panel" // İleride "Siteden mi geldi panelden mi?" diye bakmak istersen işe yarar
    });
    alert("Randevu başarıyla eklendi!");
    onComplete();
  } catch (error) {
    console.error("Hata:", error);
    alert("Bir hata oluştu.");
  }
};
  return (
    <div className="add-appointment-container">
      <div className="view-header">
        <h3>Yeni Randevu Oluştur</h3>
        <p>Telefonla veya elden alınan randevuları sisteme işleyin.</p>
      </div>

      <form onSubmit={handleSubmit} className="manual-appointment-form">
        <div className="input-grid">
          <div className="input-group">
            <label><User size={16} /> Hasta Adı Soyadı</label>
            <input 
              required 
              type="text" 
              placeholder="Örn: Ahmet Yılmaz"
              onChange={(e) => setFormData({...formData, fullName: e.target.value})} 
            />
          </div>

          <div className="input-group">
            <label><Phone size={16} /> Telefon Numarası</label>
            <input 
              required 
              type="tel" 
              placeholder="05xx..."
              onChange={(e) => setFormData({...formData, phone: e.target.value})} 
            />
          </div>

          <div className="input-group">
            <label><Calendar size={16} /> Randevu Tarihi</label>
            <input 
              required 
              type="date" 
              onChange={(e) => setFormData({...formData, date: e.target.value})} 
            />
          </div>

          <div className="input-group">
            <label><Clock size={16} /> Saat</label>
            <input 
              required 
              type="time" 
              onChange={(e) => setFormData({...formData, time: e.target.value})} 
            />
          </div>
        </div>

        <div className="input-group full-width">
          <label><FileText size={16} /> Notlar (Şikayet, Ön Bilgi vb.)</label>
          <textarea 
            rows="4" 
            placeholder="Şikayeti buraya not alabilirsiniz..."
            onChange={(e) => setFormData({...formData, notes: e.target.value})}
          ></textarea>
        </div>

        <button type="submit" className="save-btn">
          <Save size={20} /> Randevuyu Kaydet
        </button>
      </form>
    </div>
  );
};

export default AddAppointmentView;